export default "__VITE_ASSET__BRtf6r88__"